import i18n from '@/i18n/i18n';
import type { TourStep } from '@/types/help-tour';

export interface TourStepDef {
  target: string;
  spotlightFirstRow?: boolean;
  spotlightChildCount?: number;
}

/** Resolve tour step targets from locale strings in the `tours` namespace. */
export function buildTourSteps(tourId: string, defs: TourStepDef[]): TourStep[] {
  return defs.map((def, index) => ({
    target: def.target,
    title: i18n.t(`tours:${tourId}.steps.${index}.title`),
    body: i18n.t(`tours:${tourId}.steps.${index}.body`),
    ...(def.spotlightFirstRow != null ? { spotlightFirstRow: def.spotlightFirstRow } : {}),
    ...(def.spotlightChildCount != null ? { spotlightChildCount: def.spotlightChildCount } : {})
  }));
}
